module.exports = __webpack_public_path__ + "img/gift6.e712670a.png";